(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dw-walk-pricing"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('dw-walk-pricing')) {
  customElements.define('dw-walk-pricing', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.form = this.querySelector('form');
      this.form.noValidate = true;
      this.form.addEventListener('submit', event => { event.preventDefault(); this.calculate(); });
      this.querySelector('[data-example]').addEventListener('click', () => { this.form.reset(); this.calculate(); });
      this.calculate();
    }
    calculate() {
      const values = Object.fromEntries(new FormData(this.form));
      const income = Number(values.income), costs = Number(values.costs), weeks = Number(values.weeks), days = Number(values.days), bookings = Number(values.bookings);
      const valid = this.form.checkValidity() && Object.values(values).every(value => value.trim() !== '' && Number.isFinite(Number(value))) && income >= 0 && costs >= 0 && weeks >= 1 && weeks <= 52 && days >= 1 && days <= 7 && bookings > 0;
      this.querySelector('[data-error]').hidden = valid;
      if (!valid) { this.querySelector('.dw-pricing__result').hidden = true; this.form.querySelector(':invalid')?.focus(); return; }
      this.querySelector('.dw-pricing__result').hidden = false;
      const annual = income + costs * 12, total = weeks * days * bookings;
      const pounds = new Intl.NumberFormat('en-GB', {style:'currency',currency:'GBP',minimumFractionDigits:2,maximumFractionDigits:2});
      const integer = new Intl.NumberFormat('en-GB', {maximumFractionDigits:2});
      this.querySelector('[data-price]').textContent = pounds.format(annual / total);
      this.querySelector('[data-annual]').textContent = pounds.format(annual);
      this.querySelector('[data-total]').textContent = integer.format(total);
      this.querySelector('[data-weekly]').textContent = pounds.format(annual / weeks);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["food-quiz"] && !Shopify.designMode) return;
  try {
    
(() => {
  const roots = document.querySelectorAll('[data-food-quiz]');
  roots.forEach((root) => {
    if (root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    const form = root.querySelector('[data-quiz-form]');
    const steps = Array.from(root.querySelectorAll('[data-step]'));
    const back = root.querySelector('[data-back]');
    const next = root.querySelector('[data-next]');
    const submit = root.querySelector('[data-submit]');
    const results = root.querySelector('[data-results]');
    const primary = root.querySelector('[data-primary-result]');
    const secondary = root.querySelector('[data-secondary-result]');
    const alternativeWrap = root.querySelector('.dw-food-quiz__alternative');
    const restart = root.querySelector('[data-restart]');
    const progressWrap = root.querySelector('.dw-food-quiz__progress');
    const progressText = root.querySelector('[data-progress-text]');
    const progressPercent = root.querySelector('[data-progress-percent]');
    const progressBar = root.querySelector('[data-progress-bar]');
    let current = 0;

    const showStep = (index) => {
      current = Math.max(0, Math.min(index, steps.length - 1));
      steps.forEach((step, i) => { step.hidden = i !== current; });
      back.hidden = current === 0;
      next.hidden = current === steps.length - 1;
      submit.hidden = current !== steps.length - 1;
      const pct = Math.round(((current + 1) / steps.length) * 100);
      progressText.textContent = root.dataset.questionLabel + ' ' + (current + 1) + ' / ' + steps.length;
      progressPercent.textContent = pct + '%';
      progressBar.style.width = pct + '%';
    };

    const currentAnswered = () => {
      const input = steps[current].querySelector('input:checked');
      if (!input) {
        const first = steps[current].querySelector('input');
        if (first) first.focus();
        return false;
      }
      return true;
    };

    next.addEventListener('click', () => {
      if (currentAnswered()) showStep(current + 1);
    });

    back.addEventListener('click', () => showStep(current - 1));

    const avoidInputs = Array.from(form.querySelectorAll('input[name="avoid"]'));
    avoidInputs.forEach((input) => {
      input.addEventListener('change', () => {
        if (input.value === 'none' && input.checked) {
          avoidInputs.forEach((other) => { if (other !== input) other.checked = false; });
        } else if (input.checked) {
          const none = avoidInputs.find((other) => other.value === 'none');
          if (none) none.checked = false;
        }
      });
    });

    form.addEventListener('submit', (event) => {
      event.preventDefault();
      if (!currentAnswered()) return;

      const data = new FormData(form);
      const scores = { hc: 0, salmon: 0, duck: 0, beef: 0, small: 0, free: 0 };
      const allowed = new Set(Object.keys(scores));
      const add = (key, value) => { scores[key] += value; };

      if (data.get('age') === 'puppy') {
        ['hc', 'salmon', 'duck'].forEach((key) => allowed.delete(key));
      }
      if (data.get('age') === 'senior') {
        add('hc', 1); add('salmon', 1); add('free', 1);
      }

      if (data.get('size') === 'small') add('small', 2);
      if (data.get('size') === 'medium') add('free', 1);
      if (data.get('size') === 'large' || data.get('size') === 'xlarge') add('beef', 1);

      const priority = data.get('priority');
      if (priority === 'sensitive') { add('hc', 6); add('salmon', 5); add('duck', 2); }
      if (priority === 'skin') { add('salmon', 7); add('free', 2); }
      if (priority === 'smallbite') add('small', 10);
      if (priority === 'active') { add('beef', 7); add('free', 5); add('duck', 4); }
      if (priority === 'alternative') { add('duck', 7); add('salmon', 4); }
      if (priority === 'everyday') { add('free', 6); add('hc', 3); }
      if (priority === 'fussy') { add('free', 7); add('beef', 4); add('duck', 2); }

      if (data.get('grain') === 'yes') {
        allowed.delete('hc');
        allowed.delete('salmon');
        add('duck', 4); add('beef', 4); add('small', 4); add('free', 4);
      }

      const avoids = data.getAll('avoid');
      if (avoids.includes('chicken')) { allowed.delete('hc'); allowed.delete('free'); }
      if (avoids.includes('beef')) { allowed.delete('beef'); allowed.delete('small'); }
      if (avoids.includes('fish')) allowed.delete('salmon');
      if (avoids.includes('duck')) allowed.delete('duck');

      const ranked = Object.entries(scores)
        .filter(([key]) => allowed.has(key))
        .sort((a, b) => b[1] - a[1]);

      if (!ranked.length) {
        primary.innerHTML = '<p class="dw-food-quiz__eyebrow">No clear match</p><h2>{{ "food_quiz.no_match_title" | t | escape }}</h2><p>{{ "food_quiz.no_match_text" | t | escape }}</p>';
        secondary.replaceChildren();
        alternativeWrap.hidden = true;
        form.hidden = true;
        progressWrap.hidden = true;
        results.hidden = false;
        results.scrollIntoView({ behavior: 'smooth', block: 'start' });
        return;
      }

      const first = root.querySelector('template[data-result-template="' + ranked[0][0] + '"]');
      const second = ranked[1] ? root.querySelector('template[data-result-template="' + ranked[1][0] + '"]') : null;

      primary.replaceChildren(first.content.cloneNode(true));
      if (second) {
        secondary.replaceChildren(second.content.cloneNode(true));
        alternativeWrap.hidden = false;
      } else {
        secondary.replaceChildren();
        alternativeWrap.hidden = true;
      }

      const badge = document.createElement('p');
      badge.className = 'dw-food-quiz__eyebrow';
      const scoreGap = ranked[1] ? ranked[0][1] - ranked[1][1] : 99;
      badge.textContent = ranked.length === 1 ? 'Closest match from our range' : (scoreGap <= 1 ? 'Two good matches' : root.dataset.bestLabel);
      primary.prepend(badge);

      const reason = primary.querySelector('[data-personal-reason]');
      if (reason) {
        const parts = [];
        const priorityLabels = {
          sensitive: 'sensitive digestion',
          skin: 'skin & coat support',
          smallbite: 'a smaller bite size',
          active: 'a high-meat premium recipe',
          alternative: 'an alternative protein',
          everyday: 'a premium everyday food',
          fussy: 'taste appeal for a fussy eater'
        };
        if (priorityLabels[priority]) parts.push(priorityLabels[priority]);
        if (data.get('grain') === 'yes') parts.push('a grain-free recipe');
        if (avoids.length && !avoids.includes('none')) parts.push('avoiding ' + avoids.join(', '));
        reason.textContent = parts.length
          ? 'You told us you are looking for ' + parts.join(', ') + '. This recipe is the strongest fit from the Doug Walkers range based on those answers.'
          : 'This recipe is the strongest fit from the Doug Walkers range based on your answers.';
      }

      form.hidden = true;
      progressWrap.hidden = true;
      results.hidden = false;
      results.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });

    restart.addEventListener('click', () => {
      form.reset();
      results.hidden = true;
      form.hidden = false;
      progressWrap.hidden = false;
      primary.replaceChildren();
      secondary.replaceChildren();
      alternativeWrap.hidden = false;
      showStep(0);
      root.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });

    showStep(0);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();
})();
